import { render } from "./BulgogiView.vue?vue&type=template&id=44af0329"
import script from "./BulgogiView.vue?vue&type=script&lang=js"
export * from "./BulgogiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__